export default "__VITE_ASSET__f3b1c49b__"